<!-- <IFA-header></IFA-header> -->

<main id="primary" class="site-main customMain">
  <section
    id="about-insurance"
    class="section-insur types-mutual-fund-section mt-40">
    <div class="container px-4">
      <div class="row d-flex">
        <div class="col-12 MobileHide">
          <div class="sb-tag sb-offerings mb-12">market views</div>
          <h2 class="wealth-section-title mb-6">Market Outlook</h2>
          <p class="wealth-section-description">
            Let's learn about them and start your wealth journey.
          </p>
        </div>
      </div>
      <div class="pt-8 tab-wrapper mutual-fund-type md:pt-6 mobile">
        <div class="overflow-x-auto sm:-ml-4 width-xll">
          <div class="inline-block min-w-full align-middle">
            <ul
              class="CustomNavigation nav nav-tabs flex flex-no-wrap mb-1 text-center border-b-2 border-gray-200 tabs">
              <li
                class="active w-1/4 p- text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                <a data-toggle="tab" class="active d-none" href="#mutual-1">
                  News
                </a>
              </li>
              <li
                class="w-1/4 p- text-base font-semibold text-gray-500 whitespace-no-wrap border-b-2 border-white cursor-pointer sm:w-full min-w-9 lg:text-sm tab-link">
                <a data-toggle="tab" href="#mutual-2">Videos</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content">
          <div id="mutual-1" class="d-none tab-pane fade in">
            <div class="wealth-creation-features wealth-section-space px-2L">
              <div class="row">
                <div class="col-12">
                  <div class="accordion_container">
                    <div class="col-sm-12 col-md-12 col-xs-12 nopadding">
                      <div class="row">
                        <div class="col-md-12 col-xs-12 col-sm-6 nopadding">
                          <div class="accordion_head AccordianFlex">
                            <span class="contentDiv">
                              <span class="headingTitle">
                                Monthly Equity & Debt Outlook Presentation –
                                July 2022
                              </span>

                              <span class="HeadingDate">
                                07-07-2022 03:45:11 PM
                              </span>
                            </span>
                            <span class="plusminus contentDec">+</span>
                          </div>
                          <div class="accordion_body" style="display: none">
                            <div class="item-text">
                              <span
                                id="Cpbody_rptnews_Label2_0"
                                style="color: dimgray">
                                <p>
                                  Please click&nbsp;
                                  <a
                                    href="https://www.kotakmf.com/documents/Market_Outlook_July_2022"
                                    target="_blank">
                                    here
                                  </a>
                                  &nbsp;for&nbsp;
                                  <strong>
                                    Monthly Equity &amp; Debt Outlook
                                    Presentation – July 2022.
                                  </strong>
                                </p>
                                <p><strong>&nbsp;</strong></p>
                                <p><strong>Key Events:</strong></p>
                                <ul class="Custombullet ml-4">
                                  <li>
                                    Nifty (-4.8%) corrected sharply, as the
                                    markets got worried due to hawkish Fed and
                                    recession concerns
                                  </li>
                                  <li>The S&P 500 and Nasdaq corrected ~8%</li>
                                  <li>
                                    The World Bank cut India's economic growth
                                    forecast for the current fiscal to 7.5% as
                                    rising inflation, supply chain disruptions
                                    and geopolitical tensions taper recovery
                                  </li>
                                  <li>
                                    RBI's MPC decided to hike the Policy Repo
                                    Rate by 50 bps to 4.9% in its June meeting
                                  </li>
                                  <li>
                                    Gross NPA ratio of banks fell to six-year
                                    low of 5.9% in March: RBI
                                  </li>
                                  <li>
                                    The CPI inflation rate for May 2022 cooled
                                    from the 8 year high in April and came in at
                                    7.04% on the back of the base effect while
                                    WPI inflation surged to a record high of
                                    15.88% in May
                                  </li>
                                  <li>
                                    GST revenue collection for June was at Rs
                                    1.44 lakh cr; up 56% year on year
                                  </li>
                                  <li>
                                    Manufacturing PMI weakens to 53.9 in June
                                    due to rising input costs, inflation
                                    concerns
                                  </li>
                                  <li>
                                    FIIs continued being net sellers in the
                                    month of June 2022 and were net sellers to
                                    the tune of -$6.4bn even as DII buying
                                    continued at +$5.9bn
                                  </li>
                                  <li>
                                    Brent Crude was extremely volatile and
                                    touched ~$125/ barrel before correcting
                                    ~$110/ barrel
                                  </li>
                                </ul>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-12 col-xs-12 col-sm-6 nopadding mt-10">
                          <div class="accordion_head AccordianFlex">
                            <span class="contentDiv">
                              <span class="headingTitle">
                                RBI's Monetary Policy | June 2022
                              </span>
                              <span class="HeadingDate">
                                09-06-2022 02:37:41 PM
                              </span>
                            </span>
                            <span class="plusminus contentDec">+</span>
                          </div>
                          <div class="accordion_body" style="display: none">
                            <div
                              class="wealth-faq-collapse-content"
                              itemprop="text">
                              <div>
                                <span
                                  id="Cpbody_rptnews_Label2_1"
                                  style="color: dimgray">
                                  <p>
                                    Please click&nbsp;
                                    <span style="text-decoration: underline">
                                      <a
                                        href="https://www.kotakmf.com/documents/Monetary-Policy-Measures-June-2022"
                                        target="_blank">
                                        here
                                      </a>
                                    </span>
                                    &nbsp;for&nbsp;
                                    <strong>
                                      Monthly Equity &amp; Debt Outlook
                                      Presentation – Dec 2020
                                    </strong>
                                    <span style="text-decoration: underline">
                                      &nbsp;
                                    </span>
                                  </p>
                                  <p>&nbsp;</p>
                                  <p>
                                    <strong>Key Events:</strong>
                                    <strong></strong>
                                  </p>
                                  <p>&nbsp;</p>
                                  <ul class="Custombullet ml-4">
                                    <li>
                                      MPC votes unanimously to hike repo rate by
                                      50bps to 4.90%
                                    </li>
                                    <li>
                                      The MPC has dropped the phrase “remain
                                      accommodative” from the stance
                                    </li>
                                    <li>
                                      RBI increases FY23 inflation forecast by
                                      100 bps to 6.7%
                                    </li>
                                    <li>
                                      RBI retains FY23 GDP outlook at 7.2%
                                    </li>
                                    <li>
                                      RBI is likely continue to withdraw excess
                                      liquidity in a calibrated manner over a
                                      multi-year time frame
                                    </li>
                                  </ul>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-md-12 col-xs-12 col-sm-6 nopadding mt-10">
                          <div class="accordion_head AccordianFlex">
                            <span class="contentDiv">
                              <span class="headingTitle">
                                Market Outlook PPT
                              </span>
                              <span class="HeadingDate">
                                15-01-2022 01:33:40 PM
                              </span>
                            </span>
                            <span class="plusminus contentDec">+</span>
                          </div>
                          <div class="accordion_body" style="display: none">
                            <div
                              class="wealth-faq-collapse-content"
                              itemprop="text">
                              <div>
                                <span
                                  id="Cpbody_rptnews_Label2_3"
                                  style="color: dimgray">
                                  <p class="m_787248125206435224wordsection1">
                                    <span lang="EN-IN">Please click&nbsp;</span>
                                    <span style="text-decoration: underline">
                                      <span>
                                        <a
                                          href="https://www.kotakmf.com/monthly-market-update"
                                          target="_blank">
                                          here
                                        </a>
                                      </span>
                                    </span>
                                    <span lang="EN-IN">
                                      &nbsp;for&nbsp;
                                      <strong>
                                        Monthly Equity &amp; Debt Outlook
                                        Presentation – January 2020
                                      </strong>
                                    </span>
                                  </p>
                                  <p>
                                    <strong>Key Events:</strong>
                                    <strong></strong>
                                  </p>
                                  <ul class="Custombullet ml-4">
                                    <li>
                                      Nifty (+2.18%) gained 2% in the final week
                                      of 2021 after remaining under pressure in
                                      December due to incessant FII selling in
                                      India.
                                    </li>
                                    <li>
                                      The MPC unanimously voted to keep the repo
                                      rate on hold, while maintaining the
                                      “accommodative stance” with a 5-1 vote. It
                                      reiterated its growth bias in policy as
                                      the Omicron variant poses risks for the
                                      global outlook.
                                    </li>
                                    <li>
                                      The India’s manufacturing PMI hit 10-month
                                      high in Nov at 57.6, a jump from 55.9 in
                                      October. However, PMI for services dropped
                                      moderately to 58.1 in November from a
                                      ten-and-a-half-year high of 58.4 in
                                      October.
                                    </li>
                                    <li>
                                      GST revenue collected in December was over
                                      ? 1.29 lakh crore, 13 per cent higher than
                                      the same month last year.
                                    </li>
                                    <li>
                                      Headline CPI print for November came at
                                      4.91%. The surprise was driven by weaker
                                      than expected Food & Bev ex Vegetable
                                      inflation.
                                    </li>
                                    <li>
                                      The central government’s fiscal deficit as
                                      of Nov end was 46.2% of the annual budget.
                                      Total receipts at November end were
                                      Rs13.78 trn
                                    </li>
                                    <li>
                                      FIIs recorded the longest selling streak
                                      in last 10Y (26 days) with them being net
                                      sellers to the tune of -$1.7bn in Dec (YTD
                                      +$3.8bn) even as DII buying continued
                                      +$4.3bn (YTD +$12.7bn), driven by both MFs
                                      ($2.5bn) and Insurance (+$1.2bn)
                                    </li>
                                  </ul>
                                  <!-- <p>
                                    <span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Nifty (+2.18%) gained 2% in
                                      the final week of 2021 after remaining under pressure in December due to incessant FII selling in India.</span></p>
                                  <p><span class="m_787248125206435224x-rsch-run1"><span
                                        lang="EN-GB">·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_787248125206435224x-rsch-run1"><span lang="EN-GB">The MPC unanimously voted to keep the repo rate on hold, while maintaining the “accommodative stance” with a 5-1 vote. It reiterated its growth bias
                                         in policy as the Omicron variant poses risks for the global outlook.</span></span><span
                                      class="m_787248125206435224x-rsch-run1"></span></p>
                                  <p><span class="m_787248125206435224x-rsch-run1"><span
                                        lang="EN-GB">·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span>The
                                          India’s manufacturing PMI hit 10-month high in Nov at 57.6, a jump from 55.9 in October. However, PMI for services dropped moderately
                                          to 58.1 in November from a ten-and-a-half-year high of 58.4 in October.</span><span
                                      class="m_787248125206435224x-rsch-run1"></span></p>
                                  <p>
                                    <span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span
                                      lang="EN-GB">GST revenue collected in December was over ? 1.29 lakh crore, 13 per cent higher than the same month last year.</span></p>
                                  <p><span
                                      lang="EN-GB">·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span
                                      lang="EN-GB">Headline CPI print for November came at 4.91%. The surprise was driven by weaker
                                       than expected Food & Bev ex Vegetable inflation.</span></p>
                                  <p>
                                    <span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span
                                      lang="EN-GB">The central government’s fiscal deficit as of Nov end was 46.2% of the annual budget.
                                      Total receipts at November end were Rs13.78 trn</span></p>-->
                                  <!-- <span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span
                                      lang="EN-GB"> FIIs recorded the longest selling streak in last 10Y (26 days) with them being net sellers to the tune of -$1.7bn in Dec (YTD +$3.8bn) even
                                      as DII buying continued +$4.3bn (YTD +$12.7bn), driven by both MFs ($2.5bn) and Insurance (+$1.2bn)</span></p> -->
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-12 col-xs-12 col-sm-6 nopadding mt-10">
                          <div class="accordion_head AccordianFlex">
                            <span class="contentDiv">
                              <span class="headingTitle">
                                Monthly Equity & Debt Outlook Presentation –
                                September 2020.
                              </span>
                              <span class="HeadingDate">
                                14-09-2020 09:58:28 AM
                              </span>
                            </span>
                            <span class="plusminus contentDec">+</span>
                          </div>
                          <div class="accordion_body" style="display: none">
                            <div
                              class="wealth-faq-collapse-content"
                              itemprop="text">
                              <div>
                                <span
                                  id="Cpbody_rptnews_Label2_2"
                                  style="color: dimgray">
                                  <p class="m_4990020760301533491wordsection1">
                                    <span lang="EN-IN">Please click&nbsp;</span>
                                    <span style="text-decoration: underline">
                                      <span lang="EN-IN">
                                        <a
                                          href="https://assetmanagement.kotak.com/documents/19/a7a04312-5398-4387-aecb-ac8e5596439b"
                                          target="_blank">
                                          here
                                        </a>
                                      </span>
                                    </span>
                                    <span lang="EN-IN">&nbsp;</span>
                                    <span lang="EN-IN">for</span>
                                    <span lang="EN-IN">
                                      &nbsp;
                                      <strong>
                                        Monthly Equity &amp; Debt Outlook
                                        Presentation – September 2020
                                        <span>.</span>
                                      </strong>
                                    </span>
                                  </p>
                                  <p>
                                    <strong>Key Events:</strong>
                                    <strong></strong>
                                  </p>
                                  <ul class="Custombullet ml-4">
                                    <li>
                                      1Q FY21 Real GDP growth contracted by
                                      23.9% YoY, weaker than the street
                                      estimates. Led by a strict lockdown and
                                      labor migration, construction was the
                                      worst hit, followed by trade, hotels,
                                      transport and communication.
                                    </li>
                                    <li>
                                      in the rate easing cycle while refraining
                                      from giving any specific forecasts on
                                      growth &amp; inflation given heightened
                                      uncertainty.
                                    </li>
                                    <li>
                                      July’s CPI print of 6.9% (v/s 6.2% in
                                      June) drastically reduced chances of a
                                      rate cut for the rest of this fiscal year.
                                      RBI’s recent policy statement had
                                      predicted inflation to stay elevated till
                                      Sep and see moderation in 2HFY21
                                    </li>
                                    <li>
                                      India’s trade balance turned to a deficit
                                      of ~$4.8bn in July are a rare surplus of
                                      ~$0.8bn in June, as gold and other imports
                                      started to pick-up. Exports in July were
                                      down ~10% in July at $23.6bn while imports
                                      at $28.4bn.
                                    </li>
                                    <li>
                                      India’s fiscal deficit stood at Rs8.2trn
                                      at the end of July, at ~103% of the
                                      budgeted target for the current fiscal
                                      year. Sharp fall in tax receipts coupled
                                      with resilient government expenditure led
                                      to the high deficit in the period.
                                    </li>
                                    <li>
                                      After an erratic July, August witnessed
                                      excess rainfall of 26%, highest print
                                      since 1901. Rainfall is already at a
                                      record in states of Maharashtra, Madhya
                                      Pradesh, Gujarat, and Odisha.
                                    </li>
                                    <li>
                                      Indian Equities moved slightly higher
                                      (Nifty +2.8%) in August.
                                    </li>
                                  </ul>
                                  <!-- <p><span class="m_4990020760301533491x-rsch-run1"><span
                                        lang="EN-IN">·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>1Q FY21 Real GDP growth contracted
                                        by 23.9% YoY, weaker than the street estimates. Led by a strict lockdown and
                                        labor migration, construction was the worst hit, followed by trade, hotels,
                                        transport and communication.</span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span lang="EN-IN">&nbsp;</span></span>
                                  </p>
                                  <p><span class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>MPC took a&nbsp;<a
                                          href="https://www.citivelocity.com/rendition/eppublic/documentService/dXNlcl9pZD1XZ3lkd0VqeVJPR1BJcmU5OWtOX1YzNzN6NnBGNW1IUiZlbWFpbF9zZW5kX2lkPTIxMDkyOTUzNzMmdj0x/cGFyZW50X2RvY19pZD1TTC0xNzYyNzE2JmRvY19pZD05OTkzNDkmcGxhdGZvcm09NjkmdmVuZG9yPUNpdGkgVmVsb2NpdHk"
                                          target="_blank"><span>pause</span></a>&nbsp;in the rate easing cycle while
                                        refraining from giving any specific forecasts on growth &amp; inflation given
                                        heightened uncertainty.</span></span></p>
                                  <p><span class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>July’s CPI print of 6.9% (v/s 6.2%
                                        in June) drastically reduced chances of a rate cut for the rest of this fiscal
                                        year. RBI’s recent policy statement had predicted inflation to stay elevated
                                        till Sep and see moderation in 2HFY21.</span></span></p>
                                  <p><span class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>India’s trade balance turned to a
                                        deficit of ~$4.8bn in July are a rare surplus of ~$0.8bn in June, as gold and
                                        other imports started to pick-up. Exports in July were down ~10% in July at
                                        $23.6bn while imports at $28.4bn.</span></span></p>
                                  <p><span class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>India’s fiscal deficit stood at
                                        Rs8.2trn at the end of July, at ~103% of the budgeted target for the current
                                        fiscal year. Sharp fall in tax receipts coupled with resilient government
                                        expenditure led to the high deficit in the period.</span></span></p>
                                  <p><span class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>After an erratic July, August
                                        witnessed excess rainfall of 26%, highest print since 1901. Rainfall is already
                                        at a record in states of Maharashtra, Madhya Pradesh, Gujarat, and
                                        Odisha.</span></span></p>
                                  <p class="m_4990020760301533491wordsection1"><span
                                      class="m_4990020760301533491x-rsch-run1"><span>&nbsp;</span></span></p>
                                  <p><span
                                      class="m_4990020760301533491x-rsch-run1"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span></span><span
                                      class="m_4990020760301533491x-rsch-run1"><span>Indian Equities moved slightly
                                        higher (Nifty +2.8%) in August.</span></span></p> -->
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="mutual-2" class="tab-pane fade active show">
            <div class="wealth-creation-features wealth-section-space px-2L">
              <div
                class="vediosRepeaterOuter row mt-10"
                style="padding: 0 !important">
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-xs-12 vedioOuterWrapper">
                    <div
                      class="col-md-12 col-sm-12 col-xs-12 vedioInnerWrapper">
                      <iframe
                        [src]="equityMarketOutlook"
                        class="videosss"
                        allowfullscreen=""
                        frameborder="0"></iframe>
                      <!-- src="https://www.youtube.com/embed/D_FWBeIApwc"  -->
                      <div class="MatchColumnHt">
                        <span id="Cpbody_rptvideos_Label1_0"></span>
                        <!-- Equity Market Outlook - October 2022 by Mr. Harish Krishnan -->
                        <!-- Introducing Kotak Multi Asset Allocation Fund -->
                        {{ EMO_Header }}
                        <br />
                        <span id="Cpbody_rptvideos_Label4_0"></span>
                        <!-- 05/09/2023 13:23:59 -->
                        {{ EMO_date }} {{ EMO_Time }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-6 col-xs-12 vedioOuterWrapper">
                    <div
                      class="col-md-12 col-sm-12 col-xs-12 vedioInnerWrapper">
                      <iframe
                        [src]="Deptmarketoutlook"
                        class="videosss"
                        allowfullscreen=""
                        frameborder="0"></iframe>
                      <!-- src="https://www.youtube.com/embed/oMkzx3DtHZk"  -->
                      <div class="MatchColumnHt">
                        <span
                          id="Cpbody_rptvideos_Label1_1"
                          style="font-size: 18px"></span>
                        <!-- Debt Market Outlook - October 2022 by Mr. Abhishek Bisen -->
                        <!-- Introducing Kotak Multi Asset Allocation Fund by Mr. Nilesh Shah (Hindi) -->
                        {{ DMO_Header }}
                        <br />
                        <span
                          id="Cpbody_rptvideos_Label4_1"
                          style="font-size: 10px; color: dimgrey"></span>
                        <!-- 05/09/2023 13:23:54 -->
                        {{ DMO_date }} {{ DMO_Time }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-6 col-xs-12 vedioOuterWrapper">
                    <div
                      class="col-md-12 col-sm-12 col-xs-12 vedioInnerWrapper">
                      <iframe
                        [src]="Deptmarketoutlook1"
                        class="videosss"
                        allowfullscreen=""
                        frameborder="0"></iframe>
                      <!-- src="https://www.youtube.com/embed/AJ0Xq1l9XJI"  -->
                      <div class="MatchColumnHt">
                        <span id="Cpbody_rptvideos_Label1_2"></span>
                        <!-- Equity Market Outlook - July 2022 by Mr. Pankaj Tibrewal -->
                        <!-- Introducing Kotak Multi Asset Allocation Fund by Mr. Nilesh Shah | Load It. Latch It. Leave It. -->
                        {{ DMO1_Header }}
                        <br />
                        <span id="Cpbody_rptvideos_Label4_2"></span>
                        <!-- 05/09/2023 15:47:20 -->
                        {{ DMO1_date }} {{ DMO1_Time }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6 col-md-6 col-xs-12 vedioOuterWrapper">
                    <div
                      class="col-md-12 col-sm-12 col-xs-12 vedioInnerWrapper">
                      <iframe
                        [src]="Deptmarketoutlook2"
                        class="videosss"
                        allowfullscreen=""
                        frameborder="0"></iframe>
                      <!-- src="https://www.youtube.com/embed/YhZrY2cap7w"  -->
                      <div class="MatchColumnHt">
                        <span id="Cpbody_rptvideos_Label1_3"></span>
                        <!-- Debt Market Outlook - July 2022 by Mr. Deepak Agrawal - -->
                        <!-- Introducing Kotak Multi Asset Allocation Fund | Load It. Latch It. Leave It. -->
                        {{ DMO2_Header }}
                        <br />
                        <span id="Cpbody_rptvideos_Label4_3"></span>
                        <!-- 05/09/2023 15:46:23 -->
                        {{ DMO2_date }} {{ DMO2_Time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<IFA-footer></IFA-footer>
